export const ROLE_COLORS: Record<string, { bg: string; text: string; nickname: string }> = {
  '站长': {
    bg: 'bg-yellow-100',
    text: 'text-yellow-700',
    nickname: 'text-yellow-600',
  },
  '超级管理员': {
    bg: 'bg-purple-100',
    text: 'text-purple-700',
    nickname: 'text-purple-600',
  },
  '管理员': {
    bg: 'bg-orange-100',
    text: 'text-orange-700',
    nickname: 'text-orange-600',
  },
  '频道主': {
    bg: 'bg-blue-100',
    text: 'text-blue-700',
    nickname: 'text-blue-600',
  },
  '志愿者': {
    bg: 'bg-red-100',
    text: 'text-red-700',
    nickname: 'text-red-600',
  },
  '吧主': {
    bg: 'bg-green-100',
    text: 'text-green-700',
    nickname: 'text-green-600',
  },
  '吧务': {
    bg: 'bg-teal-100',
    text: 'text-teal-700',
    nickname: 'text-teal-600',
  },
  '资深用户': {
    bg: 'bg-indigo-100',
    text: 'text-indigo-700',
    nickname: 'text-indigo-600',
  },
  '荣誉成员': {
    bg: 'bg-pink-100',
    text: 'text-pink-700',
    nickname: 'text-pink-600',
  },
  '普通用户': {
    bg: 'bg-gray-100',
    text: 'text-gray-700',
    nickname: 'text-gray-900',
  },
};

export const ROLE_LABELS_ZH: Record<string, string> = {
  '站长': '[站长]',
  '超级管理员': '[超管]',
  '管理员': '[管理]',
  '频道主': '[频道主]',
  '志愿者': '[志愿者]',
  '吧主': '[吧主]',
  '吧务': '[吧务]',
  '资深用户': '[资深]',
  '荣誉成员': '[荣誉]',
  '普通用户': '',
};

export const ROLE_LABELS_EN: Record<string, string> = {
  '站长': '[Master]',
  '超级管理员': '[Super Admin]',
  '管理员': '[Admin]',
  '频道主': '[Channel Owner]',
  '志愿者': '[Volunteer]',
  '吧主': '[Forum Owner]',
  '吧务': '[Moderator]',
  '资深用户': '[Senior]',
  '荣誉成员': '[Honor]',
  '普通用户': '',
};

export const getRoleStyle = (role: string) => {
  return ROLE_COLORS[role] || ROLE_COLORS['普通用户'];
};

export const getRoleLabel = (role: string) => {
  return ROLE_LABELS_ZH[role] || '';
};

export const getRoleClass = (role: string) => {
  const style = getRoleStyle(role);
  return `${style.bg} ${style.text}`;
};

export const getNicknameColor = (role: string) => {
  return getRoleStyle(role).nickname;
};